module.exports = __webpack_public_path__ + "img/leabank@2x.f28ad5e.png";